import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with auth interceptor
const api = axios.create({
  baseURL: API
});

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const shipmentAPI = {
  // Create shipment
  createShipment: async (data) => {
    const response = await axios.post(`${API}/shipments`, data);
    return response.data;
  },

  // Calculate price
  calculatePrice: async (data) => {
    const response = await axios.post(`${API}/calculate-price`, data);
    return response.data;
  },

  // Track shipment
  trackShipment: async (trackingNumber) => {
    const response = await axios.get(`${API}/track/${trackingNumber}`);
    return response.data;
  },

  // Get shipments by phone
  getShipmentsByPhone: async (phone) => {
    const response = await axios.get(`${API}/shipments/phone/${phone}`);
    return response.data;
  }
};

export const adminAPI = {
  // Login
  login: async (username, password) => {
    const response = await axios.post(`${API}/admin/login`, { username, password });
    return response.data;
  },

  // Get dashboard stats
  getDashboardStats: async () => {
    const response = await api.get('/admin/dashboard/stats');
    return response.data;
  },

  // Get all shipments
  getAllShipments: async () => {
    const response = await api.get('/admin/shipments');
    return response.data;
  },

  // Update shipment status
  updateShipmentStatus: async (trackingNumber, status) => {
    const response = await api.patch(`/admin/shipments/${trackingNumber}/status`, { status });
    return response.data;
  },

  // Delete shipment
  deleteShipment: async (trackingNumber) => {
    const response = await api.delete(`/admin/shipments/${trackingNumber}`);
    return response.data;
  },

  // Search shipments
  searchShipments: async (query) => {
    const response = await api.get(`/admin/shipments/search/${query}`);
    return response.data;
  }
};
